import { gql } from '@apollo/client'

const METADATA_NODE_FRAGMENT = gql`
  fragment MetadataNodeFragment on MetadataNode {
    id
    name
    parentId
    position
    isCurationEnabled
    level
    idPath
    namePath
  }
`

export default METADATA_NODE_FRAGMENT
